import loadable from '@loadable/component';
import { NO_SSR } from 'shared/constants/loadable';

/* istanbul ignore next */
export const NewbuildingBrokerProfessionalAccessBlockedModalLoadable = loadable(
  () =>
    import('@cian/frontend-newbuilding-broker-callback-component').catch(() => ({
      ProfessionalAccessBlockedModal: () => null,
    })),
  {
    resolveComponent: ({ ProfessionalAccessBlockedModal }) => ProfessionalAccessBlockedModal,
    ssr: NO_SSR,
  },
);
